module.exports = __webpack_public_path__ + "static/media/04_html_placemark_example.0cba043c.png";